import type { RecommendationDataProvider, ProductCardItem } from '../types';
import type { PopularItemsParams } from './types';

/**
 * Создает провайдер для популярных товаров
 * @param fetchPopularItems - Функция для получения популярных товаров из проекта
 * @returns Провайдер данных для популярных товаров
 */
export function createPopularProvider(
  fetchPopularItems: (limit: number) => Promise<ProductCardItem[]>
): RecommendationDataProvider<PopularItemsParams> {
  return {
    /**
     * Получает популярные товары
     */
    async fetch(params: PopularItemsParams): Promise<ProductCardItem[]> {
      const limit = params.limit ?? 10;
      return await fetchPopularItems(limit);
    },

    /**
     * Возвращает параметры по умолчанию
     */
    getDefaultParams(): PopularItemsParams {
      return {
        limit: 10,
      };
    },
  };
}

